<template>
    <v-list>
        <v-list-item-group>
            <v-list-item
                v-for="(question, i) in questions"
                :key="i"
                nuxt
                :to="{name: 'id', params: { id: question.id }}"
                class="text-truncate"
            >
                <section class="v-list-item__content">
                    <h3 class="v-list-item__title">{{ question.title }}</h3>
                </section>
                <v-list-item-icon>
                    <v-icon color="#36cefc">mdi-chevron-right</v-icon>
                </v-list-item-icon>
            </v-list-item>
        </v-list-item-group>
    </v-list>
</template>

<script>
export default {
    name: 'QuestionsCategoryList',
    props: {
        categoryId: Number,
        subcategoryId: Number
    },
    data: () => ({
    }),
    computed: {
        questions () {
            if (this.$route.params.id !== null && this.$route.params.id !== undefined) {
                const questions = this.$store.getters.getQuestionBySubId(this.subcategoryId)
                console.log(questions)
                const index = questions.map((e) => { return e.id }).indexOf(parseInt(this.$route.params.id))
                console.log(index)
                if (index > -1) { questions.splice(index, 1) }
                return questions
            } else {
                return this.$store.getters.getQuestionBySubId(this.subcategoryId)
            }
        }
    }
}
</script>
